<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import { useDataModelDisplayNames } from '#layers/data-model/public';
import { RenderPageActions } from '#layers/workspace/components/page-slot-provider';
import { useCollectionRoutes } from '#layers/workspace/composables/use-collection-routes';

const props = defineProps<{
	collection: ResolvedMonospaceCollection;
	backRoute?: RouteLocationRaw;
}>();

const appConfig = useAppConfig();
const { listingRoute } = useCollectionRoutes(() => props.collection);
const backRoute = computed(() => props.backRoute ?? listingRoute.value);
const { getCollectionDisplayName } = useDataModelDisplayNames();
</script>

<template>
	<div
		class="
			relative flex shrink-0 items-center justify-between border-b px-page ps-2 block-(--secondary-header-height)
			sm:ps-3
		"
	>
		<DButton
			:icon="appConfig.ui.icons.back"
			color="neutral"
			variant="ghost"
			size="sm"
			:to="backRoute"
			class="truncate"
		>
			{{ $t('common.back_to', { name: getCollectionDisplayName(collection) }) }}
		</DButton>

		<div class="flex shrink-0 items-center gap-2">
			<RenderPageActions />
		</div>
	</div>
</template>
